import { useLocation, useNavigate } from "react-router-dom";
import { useLang } from "@/i18n";
import { useContent } from "@/content/ContentContext";
import { scrollToHash } from "@/App";
import { FriendlyBadges } from "@/components/FriendlyBadges";

const Footer = () => {
  const { t } = useLang();
  const { site, waLink } = useContent();
  const navigate = useNavigate();
  const location = useLocation();

  const links = [
    { label: t.nav.locale, hash: "#locale" },
    { label: t.nav.menu, path: "/menu" },
    { label: t.nav.servizi, path: "/servizi" },
    { label: t.nav.gallery, hash: "#gallery" },
    { label: t.nav.contatti, hash: "#contatti" },
  ];

  const go = (item) => {
    if (item.path) {
      navigate(item.path);
      window.__lenis?.scrollTo(0, { immediate: true });
      return;
    }
    if (location.pathname !== "/") navigate("/", { state: { scrollTo: item.hash } });
    else scrollToHash(item.hash);
  };

  return (
    <footer className="bg-bordeaux text-ivory" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-20 md:py-32">
        <div className="grid md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-7">
            <img
              src="/images/logo-white.png"
              alt="U Magazin"
              className="h-20 md:h-32 w-auto"
              loading="lazy"
              width="1888"
              height="620"
            />
            <p className="mt-6 font-serif italic text-lg md:text-2xl text-ivory/70">
              {t.footer.tagline}
            </p>
          </div>
          <div className="md:col-span-5 md:text-right">
            <a
              href={waLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="btn-light"
            >
              WhatsApp · {t.nav.book}
            </a>
          </div>
        </div>

        <div className="mt-16 md:mt-24 pt-12 border-t border-ivory/15 grid md:grid-cols-3 gap-12">
          <div>
            <p className="eyebrow text-sand mb-6">
              {t.footer.navigate}
            </p>
            <ul className="space-y-3">
              {links.map((l, i) => (
                <li key={i}>
                  <button
                    onClick={() => go(l)}
                    data-testid={`footer-nav-${i}`}
                    className="text-ivory/80 hover:text-ivory transition-colors duration-300"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="eyebrow text-sand mb-6">
              {t.footer.contacts}
            </p>
            <ul className="space-y-3 text-ivory/80">
              <li>
                <a
                  href={site.phoneHref}
                  data-testid="footer-phone-link"
                  className="hover:text-ivory transition-colors duration-300"
                >
                  {site.phoneDisplay}
                </a>
              </li>
              <li data-testid="footer-address">{site.address}</li>
            </ul>
          </div>
          <div className="md:text-right flex flex-col md:items-end gap-6">
            <FriendlyBadges tone="text-ivory/75" className="md:justify-end" />
          </div>
        </div>

        <div className="mt-16 md:mt-24 pt-8 border-t border-ivory/15 text-[11px] uppercase tracking-[0.2em] text-ivory/40 flex flex-col md:flex-row gap-2 md:justify-between">
          <span>{t.footer.rights}</span>
          <span>{site.island} · Sardegna</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
